import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useUploadDocumentModal } from '../context/UploadDocumentModalContext';

const UploadDocumentModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useUploadDocumentModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('UpDocument')}</h5>
      <a className="close" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default UploadDocumentModalHeader;
